(function () {
    'use strict';

    angular
        .module('app.customReport')
        .controller('customReportCtrl', ['$scope', '$modal', '$http', '$rootScope', '$modalInstance', 'customReportService', 'localStorageService',
            function ($scope, $modal, $http, $rootScope, $modalInstance, customReportService, localStorageService)
            {
                $scope.currentUser = $rootScope.currentUser;
                $scope.customReport = null;
                
                $scope.sendHttpRequest = function ()
                {
                    var result = null;
                    customReportService.getReportList($scope.selectedAdvertiser, true).then(function(result){
                            $scope.loadData(result);
                            $rootScope.$broadcast('refreshReportList');
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                    });
                }

                $scope.loadData = function(result)
                {
                    $scope.customReport = result.data;
                    $scope.flag = true;
                }

                $scope.restoreReport= function(report_id)
                {
                    var params = {
                        report_id: report_id,
                        selected_company_id: $scope.selectedAdvertiser
                    };
                    customReportService.restoreReport(params, true).then(function(result){
                            $scope.sendHttpRequest();
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                    });
                }

                $scope.sendHttpRequest();
                      
                $scope.closeModal = function()
                {
                    $modalInstance.close();
                }


                $scope.createCustomReport = function() {
                    var createCustomReportModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/measure/customReport/createCustomReport/createCustomReport.html?app_v=deployDate',
                        controller: 'createCustomReportCtrl'
                    });
                    $scope.selectedAdvertiser;
                    $scope.createCustomReportModalInstance = createCustomReportModalInstance;
                }

                $scope.detailCustomReport = function(report_id) {
                    var detailCustomReportModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/measure/customReport/detailCustomReport/detailCustomReport.html?app_v=deployDate',
                        controller: 'detailCustomReportCtrl'
                    });

                    $scope.report_id = report_id;
                    $scope.selectedAdvertiser;
                    $scope.detailCustomReportModalInstance = detailCustomReportModalInstance;
                }

                $scope.deleteCustomReport = function(report_id) {
                    var deleteCustomReportModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/measure/customReport/detailCustomReport/deleteCustomReport/deleteCustomReport.html?app_v=deployDate',
                        controller: 'deleteCustomReportCtrl',
                    });

                    $scope.customReportName;
                    $scope.reportId = report_id;
                    $scope.deleteCustomReportModalInstance = deleteCustomReportModalInstance;
                    $scope.selectedAdvertiser;
                    deleteCustomReportModalInstance.result.then(function() {
                        $scope.sendHttpRequest();
                    });
                }

                $scope.newNotificationCustomReport = function(company_id, report_id) {
                    var notificationModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/notification/partials/notificationDetail.html?app_v=deployDate',
                        controller: 'NewNotificationCtrl'
                    });

                    $scope.isCustomReport = true;
                    $scope.selectedAdvertiser = company_id;
                    $scope.selectedReport = report_id;
                    $scope.modalInstance = notificationModalInstance;
                    if($rootScope.saveParams && $rootScope.saveParams.project_id)
                    {
                        $scope.currentProjectId = $rootScope.saveParams.project_id;
                    }
                    notificationModalInstance.result.then(function() {
                        $scope.sendHttpRequest();
                    });
                };
            }
        ]);
})();
